import React, { useState, useEffect } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
/**
 * WysiwygInput
 * @param {string} initialContent
 * @param {function} onEditorChange
 */
const WysiwygInput2 = ({ initialContent, onEditorChange }) => {
  const [editorState, setEditorState] = useState(() => {
    if (initialContent) {
      const contentBlock = htmlToDraft(initialContent);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        return EditorState.createWithContent(contentState);
      }
    }
    return EditorState.createEmpty();
  });

  const handleChange = (state) => {
    setEditorState(state);
    onEditorChange(state); // 부모에게 현재 에디터 상태 전달
  };

  const uploadImageCallback = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve({ data: { link: reader.result } });
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  return (
    <div
      style={{
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "4px",
        backgroundColor: "#fafafa",
      }}
    >
      <Editor
        editorState={editorState}
        onEditorStateChange={handleChange}
        placeholder="내용을 입력하세요..."
        toolbar={{
          options: [
            "inline",
            "fontSize",
            "colorPicker",
            "list",
            "textAlign",
            "image",
          ],
          inline: {
            inDropdown: false,
            options: ["bold", "italic", "underline"],
          },
          fontSize: {
            options: [8, 10, 12, 14, 16, 18, 24, 30, 36],
          },
          colorPicker: {
            colors: [
              "#000000",
              "#FF0000",
              "#00FF00",
              "#0000FF",
              "#FF6600",
              "#9933FF",
              "#CCCCCC",
            ],
          },
          list: {
            inDropdown: false,
            options: ["unordered", "ordered"],
          },
          textAlign: {
            inDropdown: false,
            options: ["left", "center", "right"],
          },
          image: {
            urlEnabled: false,
            uploadEnabled: true,
            uploadCallback: uploadImageCallback,
            previewImage: true,
            alt: { present: false, mandatory: false },
          },
        }}
        toolbarStyle={{
          borderBottom: "1px solid #ddd",
          marginBottom: "8px",
        }}
        editorStyle={{
          width: `100%`,
          maxHeight: `400px`,
          overflowY: "auto",
          minHeight: `400px`,
          padding: "8px",
          fontSize: "14px",
          lineHeight: "1.6",
          backgroundColor: `white`,
        }}
        localization={{ locale: "ko" }}
      />
    </div>
  );
};

export default WysiwygInput2;
